class FooterNewsletter extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['email', 'fields']
  }

  connectedCallback () {
    super.connectedCallback()

    this.fieldsHeight = this.getFieldsHeight()

    this.activate()
  }

  activate () {
    this.els.fields.element.style.height = `0`
  }

  setupListeners () {
    super.setupListeners()

    this.onEmailClick = this.onEmailClick.bind(this)

    this.listeners.add(this.els.email.element, 'click', this.onEmailClick)
  }

  getFieldsHeight () {
    const fields = this.els.fields.element
    fields.style.display = 'block'

    const height = fields.offsetHeight
    fields.removeAttribute('style')

    return height
  }

  onEmailClick () {
    if (this.isOpen) return

    this.setAttribute('open', '')

    window.BAO.Utils.slideDown(this.els.fields.element, this.fieldsHeight, {
      speed: 100,
    })

    this.els.fields.element.setAttribute('aria-expanded', true)
  }

  get isOpen () {
    return this.hasAttribute('open')
  }
}

if (!customElements.get('footer-newsletter')) {
  customElements.define('footer-newsletter', FooterNewsletter)
}
